<app-form-manager
  formPlugin="hira-predefined-form"
  [params]="params"
  (canceled)="cancel($event)"
  (saveSucceed)="saveSucceed($event)"
  #form>
</app-form-manager>